<template>
  <div id="app">
    <router-view class="pt"/>
    <Footer></Footer>
  </div>
</template>

<script>
// import Header from './components/header.vue'
import Footer from './components/footer.vue'
export default {
  name: 'App',
  components:{
    // Header,
    Footer
  },
    data(){
      return{
      }
    },
    created() {
    }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
  .w1200{
    width: 1200px;
  }
  .m_0{
    margin: 0 auto;
  }
  .cp{
    cursor: pointer;
  }
  .mt30{
    margin-top: 30px;
  }
</style>
<style lang="less">
@import "./assets/style/utils.less";
.pt {
  padding-top: .px2vw(60)[@result];
}
@media screen and (max-width: 900px) {
  .pt {
    padding-top: .h5px2vw(88)[@result];
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue